import * as React from 'react';
import useStyles from './Mfa.styles';

export interface IMfaProps {}

const Mfa: React.FC<IMfaProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 57 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="26.3846" cy="26.9998" r="26.2009" fill="#F2F2F2" />
        <path
          d="M41.6579 6.16576H10.4855C8.3335 6.16576 6.58896 7.9103 6.58896 10.0623V29.545C6.58896 31.697 8.3335 33.4416 10.4855 33.4416H41.6579C43.8099 33.4416 45.5544 31.697 45.5544 29.545V10.0623C45.5544 7.9103 43.8099 6.16576 41.6579 6.16576Z"
          fill="white"
        />
        <path
          d="M41.6579 5.63198H10.4855C8.03871 5.63198 6.05519 7.6155 6.05519 10.0623V29.545C6.05519 31.9918 8.03871 33.9754 10.4855 33.9754H41.6579C44.1047 33.9754 46.0882 31.9918 46.0882 29.545V10.0623C46.0882 7.6155 44.1047 5.63198 41.6579 5.63198Z"
          stroke="black"
          strokeOpacity="0.94"
          strokeWidth="1.06755"
        />
        <path
          d="M18.2785 41.2347H33.8647"
          stroke="black"
          strokeWidth="1.06755"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0717 33.4413V41.2344"
          stroke="black"
          strokeOpacity="0.94"
          strokeWidth="1.06755"
        />
        <path
          d="M20.5171 20.5909L23.9904 24.0642C24.4073 24.4811 25.0833 24.4811 25.5002 24.0642L33.4503 16.114"
          stroke="#209AD6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="39.8609"
          y="18.4347"
          width="13.5223"
          height="23.486"
          rx="2.13509"
          fill="white"
        />
        <rect
          x="42.7075"
          y="22.179"
          width="13.5223"
          height="23.486"
          rx="2.84679"
          fill="#D4F0FF"
        />
        <path
          d="M50.4198 17.1968H42.8242C41.8496 17.1976 40.9154 17.585 40.2263 18.274C39.5373 18.9629 39.1499 19.8973 39.1491 20.8718V38.8753C39.1499 39.8498 39.5373 40.7842 40.2263 41.4732C40.9154 42.1621 41.8496 42.5496 42.8242 42.5503H50.4198C51.3943 42.5496 52.3285 42.1622 53.0176 41.4732C53.7066 40.7842 54.094 39.8499 54.0948 38.8753V20.8718C54.094 19.8973 53.7066 18.9629 53.0176 18.274C52.3285 17.585 51.3943 17.1976 50.4198 17.1968V17.1968ZM52.7603 38.8756C52.7588 39.4959 52.5118 40.0904 52.0732 40.529C51.6346 40.9676 51.04 41.2147 50.4198 41.2162H42.8242C42.2039 41.2147 41.6093 40.9676 41.1707 40.529C40.7321 40.0904 40.485 39.4958 40.4836 38.8756V20.8721C40.4851 20.2518 40.7321 19.6573 41.1707 19.2187C41.6093 18.7801 42.2039 18.533 42.8242 18.5315H43.0163C42.8273 18.9022 42.8452 19.3443 43.0632 19.6986C43.2812 20.0528 43.6679 20.2678 44.0837 20.2662H49.1544C49.5703 20.2678 49.9572 20.0528 50.1752 19.6986C50.3932 19.3443 50.4108 18.9022 50.2219 18.5315H50.414C51.0354 18.5315 51.6311 18.778 52.071 19.2168C52.5108 19.6556 52.7585 20.2509 52.76 20.8721L52.7603 38.8756Z"
          fill="black"
          fillOpacity="0.94"
        />
        <path
          d="M44.1311 30.7803L45.7243 32.3583C46.0017 32.6331 46.4486 32.6331 46.726 32.3583L50.5364 28.5842"
          stroke="#209AD6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Mfa;
